
import { mapGetters } from 'vuex'
import GoodsListPage from '@/components/GoodsListPage'

export default {
	components: {
		GoodsListPage
	},
	props: {},
	data() {
		return {
            cancelServiceMap:{CONFIDENCE_BUY:'放心购卖家权益',FAST_SELL:'极速卖卖家权益'},
			loading: false,
			cancelVisible: false,
			currentData: {},
			activeNav: '',
			navList: [
				{
					label: '全部',
					status: ''
				},
				{
					label: '待支付',
					status: 'WAIT_PAY'
				},
				{
					label: '服务中',
					status: 'IN_SERVICE'
				},
				{
					label: '已取消',
					status: 'CANCEL'
				},
				{
					label: '已退款',
					status: 'REFUND'
				}
			],
			orderList: [],
			pageInfo: {
				page: 1,
				pageSize: 10,
				total: 0
			},

			centerPayDialogVisible: false, // 支付方式
			centerPayQRDialogVisible: false, // 关闭支付提示
			parInfo: {} //创建订单回调信息
		}
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo'
		})
	},
	watch: {
		$route: {
			handler: function (route) {
				console.log('🚀 ~ route:', route)

				this.activeNav = (route.query && route.query.status) || ''
			},
			immediate: true
		}
	},
	methods: {
		// 关闭支付方式弹窗
		closePayDialogVisible(done) {
			this.centerPayQRDialogVisible = true
			if (!this.centerPayQRDialogVisible) {
				done()
			}
		},
		// 退出支付方式
		closePayDialogOkVisible() {
			this.centerPayQRDialogVisible = false
			this.centerPayDialogVisible = false
			this.$refs['qrPay'].closeDialogVisible()
		},
		// 支付成功回调
		paySuccess(payStatus, msg = '支付失败') {
			this.closePayDialogOkVisible()
			if (payStatus === 'PAY_SUCCESS') {
				this.$message.success('支付成功！')
				this.getOrderList()
			} else {
				this.centerPayDialogVisible = payStatus
			}
		},
		handleChangeNav(item) {
			this.activeNav = item.status
			this.pageInfo = {
				page: 1,
				pageSize: 10,
				total: 0
			}
			this.$router.push({
				path: '/account/serveList',
				query: {
					status: item.status
				}
			})
			this.getOrderList()
		},
		handleCurrentChange(page) {
			this.pageInfo.page = page
			this.getOrderList()
		},
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
			this.getOrderList()
		},
		getOrderList() {
			let par = {
				action: {
					status: this.activeNav,
					sellerId: this.userinfo.id
				},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$api.serveOrderList(par).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				let data = res.data
				this.orderList = data.records
				this.pageInfo.page = data.page
				this.pageInfo.total = Number(data.total)
				this.loading = false
			})
		},
		// 取消订单
		handleOpenDialog(item) {
			this.currentData = item
			this.cancelVisible = true
		},

		onPay(item) {
			this.parInfo = {
				...item,
				payName: '放心购'
			}
			this.centerPayDialogVisible = true
			this.$nextTick(() => {
				this.$refs['qrPay'].getQrCode(this.parInfo)
			})
		},

		handleConfirm() {
			let par = {
				action: {
					serviceOrderNo: this.currentData.serviceOrderNo
				}
			}
			if (this.currentData.status === 'WAIT_PAY') {
				this.$api.serveOrderCancel(par).then(res => {
					this.cancelVisible = false
					if (res.success) {
						this.$message.success('订单取消成功')
						this.getOrderList()
					} else {
						this.$message.error(res.info)
					}
				})
			} else if (this.currentData.status === 'IN_SERVICE') {
				this.$api.serveOrderRefund(par).then(res => {
					this.cancelVisible = false
					if (res.success) {
						this.$message.success('订单取消成功')
						this.getOrderList()
					} else {
						this.$message.error(res.info)
					}
				})
			}
		},
		// 订单详情
		handleDetail(item) {
			this.$router.push({
				path: '/account/serveDetails',
				query: {
					id: item.id
				}
			})
		}
	},
	mounted() {
		this.getOrderList()
	}
}
